import { listPharmacies } from './index';

import { pharmaciesRouteStore } from '../domain/store';

export default (e) => {
  pharmaciesRouteStore.setValue('filterValue', e.target.value);
  pharmaciesRouteStore.setValue('currentPage', 1);
  return listPharmacies();
};
